module.exports = "<div class=\"map-visualization-container\">\n  <div resize-event=\"handleResize()\"></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/visualizations/map/map.html
// module id = 695
// module chunks = 1